var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconHammenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.684,
    height: 18.563,
    viewBox: "0 0 20.684 18.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.795;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-2.25 -2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.139,12.841H3.046a.8.8,0,0,1,0-1.591H22.139a.8.8,0,0,1,0,1.591Z",
    transform: "translate(0 0.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.835,18.841H8.046a.8.8,0,0,1,0-1.591H21.835a.8.8,0,0,1,0,1.591Z",
    transform: "translate(0.304 0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.167,18.841H3.046a.8.8,0,0,1,0-1.591H5.167a.8.8,0,0,1,0,1.591Z",
    transform: "translate(0 0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.637,20.523a2.387,2.387,0,1,1,2.387-2.387A2.387,2.387,0,0,1,6.637,20.523Zm0-3.182a.8.8,0,1,0,.8.8A.806.806,0,0,0,6.637,17.341Z",
    transform: "translate(0.121 0.789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.167,5.841H19.046a.8.8,0,0,1,0-1.591h2.121a.8.8,0,0,1,0,1.591Z",
    transform: "translate(0.972 0.091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.835,5.841H3.046a.8.8,0,0,1,0-1.591H16.835a.8.8,0,0,1,0,1.591Z",
    transform: "translate(0 0.091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.637,7.523a2.387,2.387,0,1,1,2.387-2.387A2.387,2.387,0,0,1,17.637,7.523Zm0-3.182a.8.8,0,1,0,.8.8.806.806,0,0,0-.8-.8Z",
    transform: "translate(0.789 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHammenu);
export default __webpack_public_path__ + "static/media/icon-hammenu.000b5de658d5181bb2522c4411c15292.svg";
export { ForwardRef as ReactComponent };